// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1seZb","col":"styles_col__2Xmkv"};